import { Subject } from 'rxjs'

import { Coordinates } from '@/domain/protocols/Coordinates'

export type MapImperativeEvent =
  | {
      type: 'flyToBounds'
      bounds: [number, number, number, number]
      padding?: [number, number, number, number]
      duration?: number
    }
  | {
      type: 'flyToCoordinates'
      coordinates: Coordinates
      zoom?: number
      duration?: number
      padding?: [number, number, number, number]
    }
  | {
      type: 'zoomIn'
    }
  | {
      type: 'zoomOut'
    }
  | {
      type: 'takeScreenshot'
      callback: (screenshot: string) => void
      /**
       * Quando informado, o mapa é enquadrado nestes limites antes da captura e a câmera do usuário
       * é restaurada em seguida. Sem isso, captura-se o enquadramento atual.
       */
      bounds?: [number, number, number, number]
      padding?: [number, number, number, number]
    }

const MapImperativeSubject = new Subject<MapImperativeEvent>()

const MapImperativeInterface = {
  flyToBounds: (
    bounds: [number, number, number, number],
    padding?: [number, number, number, number],
    duration: number = 500
  ) => {
    MapImperativeSubject.next({ type: 'flyToBounds', bounds, padding, duration })
  },
  flyToCoordinates: (
    coordinates: Coordinates,
    zoom?: number,
    duration: number = 500,
    padding?: [number, number, number, number]
  ) => {
    MapImperativeSubject.next({ type: 'flyToCoordinates', coordinates, zoom, duration, padding })
  },
  zoomIn: () => {
    MapImperativeSubject.next({ type: 'zoomIn' })
  },
  zoomOut: () => {
    MapImperativeSubject.next({ type: 'zoomOut' })
  },
  takeScreenshot: (
    callback: (screenshot: string) => void,
    options?: { bounds?: [number, number, number, number]; padding?: [number, number, number, number] }
  ) => {
    MapImperativeSubject.next({ type: 'takeScreenshot', callback, ...options })
  }
}

export { MapImperativeInterface, MapImperativeSubject }
